<div class="input-container" appConfigSettingsInput>
  <app-date-input
    class="full-width"
    placeholder="{{placeholderInsurer.dateOfBirth}}"
    [form]="formGroup"
    ngDefaultControl
    [control]="formGroup.get('dateOfBirth')"
    (change)="this.emitUpdateEvent()"
    required
    isRequiredMessageKey="Calculation.RequiredField"
    [inputColor]="inputColor"
    appConfigSettingsParagraph
    [dateMask]="dateMaskFormat"
    additionalInfoInsurer="AdditionalInformation.DateOfBirth"
    [secondInsured]=secondInsured
    datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
  ></app-date-input>
  <app-toggle-input
    id="isSmoker"
    class="full-width"
    placeholder="{{placeholderInsurer.isSmoker}}"
    [form]="formGroup"
    [optionsList]="yesNoList"
    [control]="formGroup.get('isSmoker')"
    (click)="this.emitUpdateEvent()"
    required
    isRequiredMessageKey="Calculation.RequiredField"
    appConfigSettingsParagraph
    additionalInfoInsurer="AdditionalInformation.isSmoker"
    [secondInsured]=secondInsured
  ></app-toggle-input>
  <app-text-input
    id="sumAssured"
    class="full-width"
    placeholder="{{placeholderInsurer.sumAssured}}"
    [form]="formGroup"
    [control]="formGroup.get('sumAssured')"
    (change)="this.emitUpdateEvent()"
    inputMask="separator.0"
    [thousandSeparator]="thousandSeparator"
    prefix="€ "
    required
    isRequiredMessageKey="Calculation.RequiredField"
    [inputColor]="inputColor"
    appConfigSettingsParagraph
    (keyup)="onKey()"
    additionalInfoInsurer="AdditionalInformation.SumAssured"
    [secondInsured]=secondInsured
  ></app-text-input>
</div>
